

































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  Registration as IRegistration,
  RegistrationStatusEnum as ProgressStatus
} from "@/api-v2/course/models/registration";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import { progressStatusV2 } from "@/plugins/learning-status";

@Component({
  components: { CustomTableCol, CustomTableItem }
})
export default class RegistrationsProgressItem extends Vue {
  @Prop() registration!: IRegistration;

  get studentName() {
    return `${
      this.registration?.student?.lastName
        ? this.registration?.student?.lastName
        : ""
    }
    ${
      this.registration?.student?.firstName
        ? this.registration?.student?.firstName
        : ""
    }
    ${
      this.registration?.student?.middleName
        ? this.registration?.student?.middleName
        : ""
    }`;
  }

  get statusClasses() {
    let formatted: string;
    if (this.registration.status === ProgressStatus.Success) {
      formatted = "passed";
    } else if (
      this.registration.status === ProgressStatus.Fail ||
      this.registration.status === ProgressStatus.Abort
    ) {
      formatted = "not_passed";
    } else {
      formatted = "waiting";
    }

    return formatted;
  }

  translateStatus(status: ProgressStatus) {
    return progressStatusV2(status);
  }
}
